import { arrows, menu } from "./variables.js";

import { fadeIn, fadeOut } from "./fadeInOut.js";
let lastScrollTop = 0;

function scrollAction(menuAction, menuColor) {
	let scrollTop = window.scrollY || document.documentElement.scrollTop;

	scrollTop > lastScrollTop
		? menu.classList.add(menuAction)
		: menu.classList.remove(menuAction);

	lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

	window.scrollY > 500
		? menu.classList.add(menuColor)
		: menu.classList.remove(menuColor);

	if (arrows) {
		window.scrollY >= 300
			? fadeOut(arrows, 1000)
			: fadeIn(arrows, 1000, 1, "visible", "flex");
	}
}

export default scrollAction;
